<template>
  <div :class="$style.memberLevelSettingStep2">
    <el-tabs :before-leave="beforeTabLeave" ref="tab" v-model="activeTab" stretch
      class="is-no-border is-no-bg isStyleBaseLine isSecond" :class="$style.innerTabStyle" @tab-click="toClick">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index + 1}`">
      </el-tab-pane>
    </el-tabs>
    <div v-for="(tab, index) in tabList" :key="index">
      <!-- v-if="Number(activeTab) === index + 1" -->
      <keep-alive>
        <component :is="tab.component" v-if="Number(activeTab) === index + 1" @continueChangeTab="continueChangeTab"
          @updateSubmitData="updateSubmitData">
        </component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { authComputed } from '@state/helpers'

export default {
  name: 'MemberLevelSettingStep2Feature',
  data() {
    return {
      activeTab: '1',
      tabList: Object.freeze([
        {
          title: '美容服務折扣',
          component: () => import('./MemberLevelSettingStep2Service'),
          key: 'service'
        },
        {
          title: '美容服務加購折扣',
          component: () => import('./MemberLevelSettingStep2ServiceAddition'),
          key: 'addition'
        },
        {
          title: '療程方案折扣',
          component: () => import('./MemberLevelSettingStep2Prepaid'),
          key: 'prepaid'
        },
        {
          title: `儲值點數折扣`,
          component: () => import('./MemberLevelSettingStep2Deposit'),
          key: 'deposit'
        },
        {
          title: `商品購買折扣`,
          component: () => import('./MemberLevelSettingStep2Goods'),
          key: 'goods'
        },
      ]),
      userInputData: {}, // 使用者輸入資料
      isContinueChangeTab: true, // 是否可以切換tab
    }
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['dbData'],
  watch: {
    activeTab(nvl, ovl) {
    }
  },
  computed: {
    ...authComputed,
  },
  created() {
  },
  mounted() {
    if (!this.$hasDeposit()) {
      this.tabList = this.tabList.filter(item => item.key !== 'deposit')
    }
    if (!this.hasGoods) {
      this.tabList = this.tabList.filter(item => item.key !== 'goods')
    }
  },
  methods: {
    toClick() {
    },
    beforeTabLeave() {
      if (!this.isContinueChangeTab) {
        return new Promise((res, rej) => {
          rej()
        })
      } else {
        return new Promise((res, rej) => {
          res()
        })
      }
    },
    /**
     * @descriptionn 更新子組件上來的資料
     */
    updateSubmitData(nvl) {
      this.userInputData[nvl.type] = nvl
      this.$emit('updateSubmitData', nvl)
    },
    /**
     * @description 看能不能切換tab
     */
    continueChangeTab(nvl) {
      this.isContinueChangeTab = nvl
      this.$emit('continueSave', nvl)
    }
  },
  components: {},
};
</script>

<style lang="scss" module >
.memberLevelSettingStep2 {
  margin: -1.68rem -1rem 0;
}

.innerTabStyle {
  background-color: $color-body-bg;

  :global {
    .el-tabs__header {
      margin-top: -15px;
      margin-bottom: 5px;
      padding-bottom: 1px;
      box-shadow: 0 2px 5px #EFF0F1;
      margin-left: -15px;
      margin-right: -15px;

      .el-tabs__item {
        padding-left: 0;
        padding-right: 0;
        background-color: $color-body-bg !important;

        &:last-child {
          border-right: 1px solid #E5E7EB;
        }

        &.is-active {
          background-color: $color-body-bg !important;
        }
      }
    }
  }
}

:global {
  .is-second {

    .el-tabs__item {
      font-size: 14px !important;

      &.is-active {
        font-weight: normal;
        color: $color-primary !important;
      }
    }
  }
}
</style>
